<template>
  <div class="payout-to-card-view page--payout-to-card-view">
    <div class="page__header">
      <div class="page__title">
        <router-link :to="backLinkRoute" class="page__back-link">
          <arrow-button
            class="page__back-link-icon"
            :rotated180="true"
          ></arrow-button>
        </router-link>
        <div class="page__title-text">
          {{ $t('payout-to-card-view.page.title') }}
        </div>
      </div>
    </div>
    <div class="payout">
      <div class="payout__header">
        <div class="payout__number">
          {{
            $t('payout-to-card-view.payout.number', {
              payoutId: payout.operationId,
            })
          }}
        </div>
        <!--        <refresh-button class="payout__refresh" mode="plain" @click="loadPayout"></refresh-button>-->
        <transaction-status
          class="payout__status"
          :status-id="payout.operationStatus"
        ></transaction-status>
      </div>
      <template v-if="isPayoutLoaded">
        <component
          :is="detailsComponent"
          :payout="payout"
          class="payout__info"
        ></component>
        <div class="payout__actions">
          <primary-button
            v-if="detailsActions.mainAction"
            class="payout__actions-item"
            :label="detailsActions.mainAction.label"
            @click="detailsActions.mainAction.handler"
          ></primary-button>
          <no-bg-button
            v-if="detailsActions.secondaryAction"
            class="payout__actions-item"
            :icon="detailsActions.secondaryAction.icon"
            :label="detailsActions.secondaryAction.label"
            @click="detailsActions.secondaryAction.handler"
          ></no-bg-button>
        </div>
      </template>
      <template v-else>
        <div class="payout__loader">
          <loader></loader>
        </div>
      </template>
    </div>

    <!--  POPUP AND NOTIFICATIONS  -->
    <transaction-receipt-popup
      :transaction="payout"
      :pdf-blob="payoutReceiptBlob"
      ref="payoutReceiptPopup"
    ></transaction-receipt-popup>
  </div>
</template>

<script>
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'

import TransactionReceiptPopup from '@vue-app/components/company/transactions/popup/TransactionReceiptPopup.vue'
import { Transaction } from '@js-app/entities/transaction/Transaction'
import RefreshButton from '@vue-app/components/base/button/RefreshButton.vue'
import PayoutToCardDetails from '@vue-app/components/company/payouts/details/PayoutToCardDetails.vue'
import Loader from '@vue-app/components/base/Loader.vue'

export default {
  name: 'PayoutToCardView',
  components: {
    Loader,
    PayoutToCardDetails,
    RefreshButton,
    TransactionReceiptPopup,
    ArrowButton,
    NoBgButton,
    PrimaryButton,
    TransactionStatus,
  },
  props: ['id', 'payoutId'],
  data() {
    return {
      payout: new Transaction(),
      payoutReceiptBlob: null,
      isPayoutLoaded: false,
    }
  },
  created() {
    this.loadPayout()
  },
  methods: {
    async loadPayout() {
      this.isPayoutLoaded = false
      let _payoutResponse = await CompaniesApi.getPayoutToCard(
        this.id,
        this.payoutId
      )
      this.payout = new Transaction(_payoutResponse.data.ReportOperations[0])
      this.isPayoutLoaded = true
    },

    toPayoutsPage() {
      this.$router.push(RouteHelper.getRoute('payouts', { companyId: this.id }))
    },

    toCreatePayoutPage() {
      this.$router.push(
        RouteHelper.getRoute('create-payout-to-card', { companyId: this.id })
      )
    },
    repeatPayout() {
      //TODO: Make repeat payout handler
    },
  },
  computed: {
    backLinkRoute() {
      return RouteHelper.getRoute('payouts', { companyId: this.id })
    },

    detailsComponent() {
      return 'PayoutToCardDetails'
    },

    detailsActions() {
      let mainAction = null
      let secondaryAction = {
        label: this.$t('payout-to-card-view.payout.actions.back-to-history'),
        handler: this.toPayoutsPage,
        icon: null,
      }

      switch (this.payout.operationStatus.toString()) {
        case '4':
        case '5':
          mainAction = {
            label: this.$t('payout-to-card-view.payout.actions.repeat-payout'),
            handler: this.repeatPayout,
          }
          break
        default:
          mainAction = {
            label: this.$t(
              'payout-to-card-view.payout.actions.to-create-payout-page'
            ),
            handler: this.toCreatePayoutPage,
          }
      }

      return { mainAction, secondaryAction }
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--payout-to-card-view {
    padding-top: 31px;
  }
}
.payout {
  width: 100%;
  max-width: 615px;
  margin-top: 27px;
  background: #ffffff;
  border-radius: 22px;
  padding: 29px 27px 38px;
  &__loader {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__header {
    display: flex;
    align-items: center;
  }

  &__number {
    margin-left: 27px;
    margin-right: 27px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #666d79;
  }

  &__refresh {
    margin-left: auto;
    margin-right: 9px;
  }

  &__status {
    width: 105px;
    margin-left: auto;
  }

  &__info {
    margin-top: 25px;
  }

  &__actions {
    margin-top: 43px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-item {
      width: 100%;
      max-width: 290px;
      padding: 25px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
